import React from "react";

import MobileIcon from "@assets/icons/svgr/mobile.svg";
import PayAtCounterIcon from "@assets/icons/svgr/pay-at-counter.svg";

import { SignUpInputFields } from "@is/types";
import { CheckoutInputFields } from "@is/types/checkout";

export const noNumbersFields = [
  CheckoutInputFields.FirstName,
  CheckoutInputFields.LastName,
  CheckoutInputFields.City,
  SignUpInputFields.FirstName,
  SignUpInputFields.LastName,
];

export const addressFields = [
  CheckoutInputFields.Address,
  CheckoutInputFields.Address2,
  CheckoutInputFields.HouseNumber,
  CheckoutInputFields.StateRegion,
];

export const INFO_FIELDS = [
  CheckoutInputFields.FirstName,
  CheckoutInputFields.LastName,
  CheckoutInputFields.PhoneNumberOrEmail,
];

export const SUMMARY_PAGE_ADDRESS_FIELDS = [
  CheckoutInputFields.Address,
  CheckoutInputFields.HouseNumber,
  CheckoutInputFields.Address2,
];

export enum PaymentStatus {
  Loading = "loading",
  Failure = "failed",
  LinkExpired = "userNotificationLinkInvalidated",
  Success = "basketForwarded",
}

export enum ErrorType {
  Global = "global",
  LinkExpired = "linkExpired",
}

export enum CheckoutConfigurationType {
  PayAtCounter = "payAtCounter",
  UserConfirmationRequired = "userConfirmationRequired",
  QRCode = "qrCode",
}

export enum CheckoutOptionsType {
  DeliveryOptions = "deliveryOptions",
  RecipientOptions = "recipientOptions",
}

export enum DeliveryOptions {
  HomeDelivery = "homeDelivery",
  InstorePickup = "instorePickup",
}

export enum PickupInfo {
  PickupStoreAddress = "PickupStoreAddress",
  PickupStoreId = "PickupStoreId",
  PickupStoreZipCode = "PickupStoreZipCode",
  PickupStoreCity = "PickupStoreCity",
  PickupStoreCountryCode = "PickupStoreCountryCode",
}

export enum PhoneOrEmailInputField {
  Phone = "phoneNumber",
  Email = "email",
}

export const CHECKOUT_CONFIGURATIONS_TYPE_ICONS = {
  [CheckoutConfigurationType.PayAtCounter]: (
    <PayAtCounterIcon className={"text-label-2xl"} />
  ),
  [CheckoutConfigurationType.UserConfirmationRequired]: (
    <MobileIcon className={"text-label-2xl"} />
  ),
};

export const QR_CODE_SIZES = {
  Small: 128,
  Large: 240,
};

export enum QRCodeCheckoutStatus {
  Success = "BasketForwarded",
  Failed = "Failed",
  InProgress = "InProgress",
}

export const DELIVERY_OPTIONS_LABELS = {
  [DeliveryOptions.HomeDelivery]: "Home delivery",
  [DeliveryOptions.InstorePickup]: "In-store pickup",
};

export const DELIVERY_OPTIONS = [
  DeliveryOptions.HomeDelivery,
  DeliveryOptions.InstorePickup,
];
